export function loadBranding(businessId = "default"){
  try{
    let link = document.getElementById("branding-css");

    if(!link){
      link = document.createElement("link");
      link.id = "branding-css";
      link.rel = "stylesheet";
      document.head.appendChild(link);
    }

    link.href = `/branding/${businessId}.css`;
  } catch(err){
    console.error("Branding load failed:", err);
  }
}

